<template>
	<div class="menu-wrap">
		<mu-bottom-nav :value="bottomNav" @change="handleChange">
		    <mu-bottom-nav-item value="1" title="首页" class="home" icon="home"/>
		    <mu-bottom-nav-item value="2" title="分类" class="sort" icon="list"/>
		    <mu-bottom-nav-item value="3" title="购物车" class="cart" icon="shopcart">
		    	<mu-badge :content="String(cartGoodsNum)" circle secondary v-bind:badgeClass="[cartGoodsNum==0 ?'none-badge':'custom-badge']">
		    	</mu-badge>
		    </mu-bottom-nav-item>
		    <mu-bottom-nav-item value="4" title="我的" class="mine" icon="my"/>
		</mu-bottom-nav>
	</div>
</template>
<script type="text/javascript">
import {mapActions,mapGetters} from 'vuex';
	export default{
		data () {
		    return {
		      /*bottomNav: '1'*/
		    }
	 	},
	 	computed:{
	 		bottomNav(){
	 			return this.$route.meta.id ? this.$route.meta.id : '1';
	 		},
	 		...mapGetters({
               cartGoodsNum:'cartGoodsNum',//购物车商品数量
            }),
	 	},
	 	mounted() {	 		
	 		this.getCartNum();	 		
	 	},
	  	methods: {
	  		 ...mapActions({
                getCartGoodsNum:'getCartGoodsNum',//获取购物车商品数量
            }),
		    handleChange (val) {
		    	switch(val){
		    		case '1':
		    			this.$router.push({path: '/main/home'});
		    			break;
		    		case '2':
		    			this.$router.push({path: '/main/classify'});
		    			break;
		    		case '3':
		    			this.$router.push({path: '/main/cart'});
		    			break;
		    		case '4':
		    			this.$router.push({path: '/main/personal'});
		    			break;
		    	}
		    },
		    //13.9.获取购物车商品数量
            getCartNum(){
                this.getCartGoodsNum([]).then(res=>{
                   //this.cartGoodsNum = res;
                })
            },
	  	}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/common/sass/mixin.scss';
	.menu-wrap{
		.mu-badge-container{
			position: absolute;
			top: 0.2rem;
		}
		.mu-bottom-nav{
			height: 1.25rem;
			border-top: 1px solid #e5e5e5;
			background: #FEFEFE;
		}
		.mu-buttom-item{
			height: 100%;
			max-width: inherit;
			padding-top: 0.2rem;
		}
		.material-icons{
			font-size: 0;
			display: block;
			width: 0.55rem;
			height: 0.55rem;
			
		}
		.mu-bottom-item-text{
			@include font-dpr(10px);
			color: #484C62;
		}
		.home{
			i{
				background: url(/static/images/tab_home_gray_3x.png) no-repeat center;
				background-size: cover;
			}
		}
		.sort{
			i{
				background: url(/static/images/tab_kind_gray_3x.png) no-repeat center;
				background-size: cover;
			}
		}
		.cart{
			i{
				background: url(/static/images/tab_shopping_gray_3x.png) no-repeat center;
				background-size: cover;
			}
		}
		.mine{
			i{
				background: url(/static/images/tab_personal_gray_3x.png) no-repeat center;
				background-size: cover;
			}
		}
		.home{
			&.mu-bottom-item-active{
				i{
					background: url(/static/images/tab_home_red_3x.png) no-repeat center;
					background-size: cover;
				}
				.mu-bottom-item-text{
					color: #E60012;
				}
			}
		}
		.sort{
			&.mu-bottom-item-active{
				i{
					background: url(/static/images/tab_kind_red_3x.png) no-repeat center;
					background-size: cover;
				}
				.mu-bottom-item-text{
					color: #E60012;
				}
			}
		}
		.cart{
			&.mu-bottom-item-active{
				i{
					background: url(/static/images/tab_shopping_red_3x.png) no-repeat center;
					background-size: cover;
				}
				.mu-bottom-item-text{
					color: #E60012;
				}
			}
		}
		.mine{
			&.mu-bottom-item-active{
				i{
					background: url(/static/images/tab_personal_red_3x.png) no-repeat center;
					background-size: cover;
				}
				.mu-bottom-item-text{
					color: #E60012;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// menus.vue?2ee26e7b